// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_1T","trigger":"e_2T","tip":"e_3T","tipEnd":"e_4T","tipOpen":"e_5T","link":"e_6T"};